import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
  width: 90vw;
`;
